var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './core-6f498fd9.js';
import { T as TextfieldType } from './textfield.type-6ef76b70.js';
var CsmSearchableSelect = /** @class */ (function () {
    function CsmSearchableSelect(hostRef) {
        registerInstance(this, hostRef);
        this.allItems = [];
        this.filteredItems = [];
        this.lastSearch = '';
        this.hidingClassName = 'hidden';
        this.lastSearchScheduleId = -1;
        this.isOpen = false;
        this.selectInputLabel = '';
        this.disabled = false;
        this.preventDefault = false;
        this.icon = 'search';
        this.csmChange = createEvent(this, "csmChange", 7);
        this.csmSearchInput = createEvent(this, "csmSearchInput", 7);
        this.csmOpen = createEvent(this, "csmOpen", 7);
        this.csmClose = createEvent(this, "csmClose", 7);
    }
    Object.defineProperty(CsmSearchableSelect.prototype, "options", {
        get: function () {
            return __spreadArrays(this.host.querySelectorAll('csm-select-item'));
        },
        enumerable: true,
        configurable: true
    });
    CsmSearchableSelect.prototype.componentDidLoad = function () {
        var _this = this;
        this.getSelectItemsFromDom();
        this.initSelectedItem();
        this.mutationObserver = new MutationObserver(function () {
            _this.getSelectItemsFromDom();
            _this.setSelectedItem();
        });
        this.mutationObserver.observe(this.host, { childList: true });
    };
    CsmSearchableSelect.prototype.disconnectedCallback = function () {
        this.mutationObserver.disconnect();
    };
    /**
     * Make a mapping which links the value of each item of the select list to
     * the item itself. Thus allowing to search an item element by value
     * instead of having to loop through the whole child node list at each search.
     */
    CsmSearchableSelect.prototype.getSelectItemsFromDom = function () {
        var _this = this;
        this.allItems = [];
        this.host.childNodes.forEach(function (node) {
            // DOM nodes which are not csm-select-item elements won't need to be filtered
            if (node.nodeName === 'CSM-SELECT-ITEM') {
                _this.allItems.push(node);
            }
        });
    };
    CsmSearchableSelect.prototype.setSelectedItem = function () {
        var _this = this;
        this.selectedItem = this.allItems.find(function (itemElement) { return itemElement.value === _this.value; });
        if (!this.isOpen) {
            this.setSearchInputToSelectedItemText();
        }
    };
    CsmSearchableSelect.prototype.initSelectedItem = function () {
        var _a;
        if (this.value && this.value.length && ((_a = this.selectedItem) === null || _a === void 0 ? void 0 : _a.value) !== this.value) {
            this.setSelectedItem();
        }
        else if (!this.value) {
            this.resetSearchInput();
        }
    };
    CsmSearchableSelect.prototype.setSearchInputToSelectedItemText = function () {
        var _a;
        this.setSearchInput((_a = this.selectedItem) === null || _a === void 0 ? void 0 : _a.textContent);
    };
    CsmSearchableSelect.prototype.setSearchInput = function (textContent) {
        this.selectInputLabel = (textContent !== null && textContent !== void 0 ? textContent : '');
    };
    CsmSearchableSelect.prototype.changeSelection = function (item) {
        this.selectedItem = item;
        this.value = item.value;
        this.selectInputLabel = item.text;
        this.csmChange.emit(this.value);
        this.close();
    };
    CsmSearchableSelect.prototype.close = function (event) {
        var _a;
        if (((_a = event) === null || _a === void 0 ? void 0 : _a.realTarget) === this.host) {
            delete event.realTarget;
            return;
        }
        this.isOpen = false;
        this.setSearchInputToSelectedItemText();
        this.csmClose.emit();
    };
    ;
    CsmSearchableSelect.prototype.open = function () {
        var _this = this;
        if (this.disabled || this.isOpen) {
            return;
        }
        this.resetSearchInput();
        this.unfilterItems();
        setTimeout(function () {
            _this.isOpen = true;
            setTimeout(_this.scrolToDropdown.bind(_this), 100);
        });
        this.csmOpen.emit();
    };
    CsmSearchableSelect.prototype.scrolToDropdown = function () {
        this.dropdown && this.dropdown.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    };
    CsmSearchableSelect.prototype.resetSearchInput = function () {
        this.setSearchInput();
        this.csmSearchInput.emit('');
    };
    /**
     * Kind of a debounce system which avoids triggering the search process
     * right away at each keystroke. Thus avoiding iterating over a huge list
     * while the user is not done writing his search keyword.
     */
    CsmSearchableSelect.prototype.scheduleNextSearch = function (event) {
        var _this = this;
        var _a;
        var debounceTimeout = 200;
        var searchInput = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.value;
        window.clearTimeout(this.lastSearchScheduleId);
        this.lastSearchScheduleId = window.setTimeout(function () { return _this.searchInList(searchInput); }, debounceTimeout);
    };
    /**
     * Don't filter if the component's user wants to overload the default search
     * behaviour.
     * Avoid as much as possible searching in the whole set of values provided
     * at initialization.
     */
    CsmSearchableSelect.prototype.searchInList = function (searchInput) {
        this.csmSearchInput.emit(searchInput);
        if (this.preventDefault) {
            return;
        }
        searchInput = searchInput.toLowerCase();
        var nothingToSearch = this.setSearchScope(searchInput);
        if (nothingToSearch) {
            return;
        }
        this.filterItems(searchInput);
        this.lastSearch = searchInput;
    };
    /**
     * Define the scope of elements in which the search should be made.
     * That is, determine whether the next search should be made only within the
     * subset of the previous search or within the whole set of values the select
     * list was initialized with.
     * @returns True if the search input is empty. Which means there is no nead
     * to perform a search until the next call.
     */
    CsmSearchableSelect.prototype.setSearchScope = function (searchInput) {
        var nothingToSearch = !searchInput || !searchInput.trim().length;
        var lessCharsThanPreviousSearch = searchInput.length < this.lastSearch.length;
        var asMuchCharsButDifferentSearch = searchInput.length === this.lastSearch.length && searchInput !== this.lastSearch;
        if (nothingToSearch || lessCharsThanPreviousSearch || asMuchCharsButDifferentSearch) {
            this.unfilterItems();
        }
        return nothingToSearch;
    };
    CsmSearchableSelect.prototype.unfilterItems = function () {
        var _this = this;
        this.filteredItems.forEach(function (itemElement) {
            itemElement.classList.remove(_this.hidingClassName);
        });
        this.filteredItems = [];
    };
    /**
     * Use the host's child nodes to retrieve the select list items which should
     * be filtered.
     */
    CsmSearchableSelect.prototype.filterItems = function (searchInput) {
        var _this = this;
        this.allItems.forEach(function (itemElement) {
            var isAlreadyHidden = itemElement.classList.contains(_this.hidingClassName);
            if (isAlreadyHidden) {
                return;
            }
            var matchPosition = itemElement.textContent.toLowerCase().indexOf(searchInput);
            // Filter only elements whose text content contains the given keyword
            if (matchPosition > -1) {
                return;
            }
            _this.hideItem(itemElement);
        });
    };
    /**
     * Hide the given item and add it to the list of hidden items for
     * a later prospective bulk display reset.
     */
    CsmSearchableSelect.prototype.hideItem = function (itemElement) {
        this.filteredItems.push(itemElement);
        itemElement.classList.add(this.hidingClassName);
    };
    CsmSearchableSelect.prototype.render = function () {
        var _this = this;
        var inputProps = {
            disabled: this.disabled,
            type: TextfieldType.Text,
            placeholder: this.placeholder,
            value: this.selectInputLabel,
            onCsmFocus: function () { return _this.open(); },
            onCsmChange: function (e) { return _this.scheduleNextSearch(e); },
        };
        return (h(Host, { onClick: function (e) {
                e.realTarget = e.target;
            } }, h("csm-input", Object.assign({}, inputProps), h("csm-icon", { onClick: function () { return _this.open(); }, name: "angle-down", slot: "right-icon" }), this.icon && h("csm-icon", { name: this.icon, slot: "left-icon" })), this.isOpen && (h("csm-dropdown-list", { class: "dropdown", ref: function (el) { return (_this.dropdown = el); }, onCsmItemClick: function (e) { return _this.changeSelection(e.detail.host); } }, h("slot", null)))));
    };
    Object.defineProperty(CsmSearchableSelect.prototype, "host", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSearchableSelect, "watchers", {
        get: function () {
            return {
                "value": ["initSelectedItem"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSearchableSelect, "style", {
        get: function () { return "\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:400;src:url(../assets/fonts/ProximaNova-Regular.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Regular.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:600;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:700;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:900;src:url(../assets/fonts/ProximaNova-Black.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Black.woff) format(\"woff\")}\@font-face{font-family:CS-FontIcon-v19;src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb);src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb#iefix) format(\"embedded-opentype\"),url(../assets/icons/CS-FontIcon-v19.ttf?cz1hbb) format(\"truetype\"),url(../assets/icons/CS-FontIcon-v19.woff?cz1hbb) format(\"woff\"),url(../assets/icons/CS-FontIcon-v19.svg?cz1hbb#CS-FontIcon-v18) format(\"svg\");font-weight:400;font-style:normal;font-display:block}:root{font-family:Proxima Nova,sans-serif}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box;font-family:inherit}:host{width:inherit;display:block;position:relative;--searchable-select-dropdown-width:inherit}:host ::slotted(.hidden){display:none}:host .disabled{cursor:default}:host .dropdown{position:absolute;width:var(--searchable-select-dropdown-width,inherit);z-index:50;margin-top:12px}:host([error]) csm-input::part(input){border:1px solid #d94c62}:host([error]) csm-input::part(input)::-webkit-input-placeholder{border:none}:host([error]) csm-input::part(input)::-moz-placeholder{border:none}:host([error]) csm-input::part(input):-ms-input-placeholder{border:none}:host([error]) csm-input::part(input)::-ms-input-placeholder{border:none}:host([error]) csm-input::part(input)::placeholder{border:none}"; },
        enumerable: true,
        configurable: true
    });
    return CsmSearchableSelect;
}());
export { CsmSearchableSelect as csm_searchable_select };
